import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=31eea77f&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=31eea77f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eea77f",
  null
  
)

export default component.exports